'use client';

import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from './utils';

const Switch = React.forwardRef<
    React.ElementRef<typeof SwitchPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, checked, ...props }, ref) => (
    <SwitchPrimitive.Root
        ref={ref}
        className={cn(
            'flex h-5 w-9 rounded-full p-2px disabled:opacity-10',
            checked && 'justify-end bg-blue-600 hover:bg-blue-700',
            !checked && 'bg-gray-300 hover:bg-gray-400',
            className
        )}
        {...props}
    >
        <SwitchPrimitive.Thumb
            ref={ref}
            className={cn('block w-4 h-4 bg-white flex-shrink-0 rounded-full')}
            {...props}
        />
    </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;

export default Switch;
